import { debug as debugGen } from "debug";
import config from "../config";
import { TraceInfo } from "../actionTypes";
import { LatestTrace } from "../types";

const debug = debugGen("vtTracker:AbstractStore");

export interface TraceStoreItem {
    time: number;
    trace: LatestTrace;
}

export type StorePartialTrace = Partial<TraceInfo>;

export abstract class AbstractStore {
    static adaptTrace(time: number, trace: LatestTrace): StorePartialTrace {
        const tmp: StorePartialTrace = {};

        if (time > 0 && trace) {
            const timePast = Date.now() - time;

            if (timePast <= config.traceExpired) {
                if (typeof trace.traceId !== "undefined") {
                    tmp.trace_id = trace.traceId;
                }

                if (typeof trace.traceIndex !== "undefined") {
                    tmp.trace_index = trace.traceIndex;
                }

                if (typeof trace.traceNum !== "undefined") {
                    tmp.trace_num = trace.traceNum;
                }

                if (typeof trace.traceDetail !== "undefined") {
                    tmp.trace_detail = JSON.stringify(trace.traceDetail);
                }
            } else {
                debug("store trace has expired, past %dms", timePast);
            }
        }

        return tmp;
    }

    protected parseStore(storeStr: string): StorePartialTrace {
        const { time, trace }: TraceStoreItem = JSON.parse(storeStr || "{}");

        return AbstractStore.adaptTrace(time, trace);
    }

    protected trace2Item(trace: LatestTrace): TraceStoreItem {
        return {
            time: Date.now(),
            trace
        };
    }

    abstract async setItem(key: string, data: LatestTrace): Promise<number>;

    abstract async getItem(key: string): Promise<StorePartialTrace>;

    abstract async removeItem(key: string): Promise<number>;
}
